import styled from 'styled-components'
import { size } from 'ui/themes/utils'

import Icon from 'ui/blocks/Icon'

export const Period = styled.div`
  cursor: pointer;

  ${Icon} {
    font-size: 12px;
    margin: 0 ${size('margin', 'xs')};

    &:last-child {
      margin-right: 0;
    }
  }
`

export const Details = styled.div`
  display: flex;
  flex-flow: row nowrap;

  justify-content: space-between;
  align-items: center;

  font-size: 14px;
  text-align: left;
`

export const Detail = styled.div``

export const Location = styled.p`
  font-size: 13px !important;
  font-weight: 500 !important;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const DateTime = styled.p`
  font-size: 12px !important;
  font-weight: 300 !important;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:first-letter {
    text-transform: uppercase;
  }
`

export const ChoosePeriod = styled.p`
  width: 100%;
  text-align: center;
  font-size: 14px !important;
`

const DatesBase = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  padding: ${size('padding', 'sm')} ${size('padding', 'md')} !important;
`

export const WithDates = styled(DatesBase)`
  ${Details} {
    width: calc(100% - 12px - (1.5 * ${size('padding', 'md')}));
  }

  ${Icon} {
    &:last-child {
      position: absolute;

      top: 50%;
      right: ${size('padding', 'md')};

      transform: translateY(-50%);
    }
  }
`

export const NoDates = styled(DatesBase)`
  ${Icon} {
    &:last-child {
      position: absolute;

      top: 50%;
      right: ${size('padding', 'md')};

      transform: translateY(-50%);
    }
  }
`

export const Placeholder = styled.p`
  font-size: 14px !important;
`
